var map = {
	"./csv.svg": "9bac",
	"./doc.svg": "829f",
	"./docx.svg": "8c22",
	"./image.svg": "4906",
	"./mov.svg": "3153",
	"./mp3.svg": "fad8",
	"./mp4.svg": "2767",
	"./pdf.svg": "304e",
	"./ppt.svg": "ee82",
	"./pub.svg": "ec0f",
	"./rar.svg": "ab2c",
	"./txt.svg": "0586",
	"./video.svg": "e85b",
	"./xls.svg": "a36e",
	"./zip.svg": "4930"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f389";